import React from 'react';

const NoAccess: React.FC = () => (
    <div>
        <h2>No Access</h2>
        <p>You do not have permission to view this page.</p>
    </div>
);

export default NoAccess;
